import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import type { OutreachLiveWarmup } from '../../outreachTypes';
import { PlugPulse } from './PlugPulse';
import { dayWord, nextPickCount } from './upNextCopy';
import { upNextMessages as messages } from './upNextMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Up next; each part uses its own slice of it */
import styles from './UpNext.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PlugLineProps {
  nextBatchAt: string;
  now: Date;
  rate: number | null;
  warmup: OutreachLiveWarmup | null;
}

/** "Plug is working. It checks new fits and picks the next 3 tomorrow at 06:05." (design s3, s4). */
const PlugLineComponent: React.FC<PlugLineProps> = ({ nextBatchAt, now, rate, warmup }) => {
  const intl = useIntl();
  const day = dayWord(intl, nextBatchAt, now);
  const count = nextPickCount(rate, warmup, nextBatchAt);
  const time = intl.formatTime(new Date(nextBatchAt), { hour: '2-digit', minute: '2-digit' });
  return (
    <div className={styles.plugLine} data-testid="plug-line">
      <PlugPulse size={16} />
      {count === null || count === 0
        ? intl.formatMessage(messages.plugWorkingNoCount, { day, time })
        : intl.formatMessage(messages.plugWorking, { count, day, time })}
    </div>
  );
};

export const PlugLine = TypedMemo(PlugLineComponent);
